import classNames from 'classnames/bind';
import React, { useMemo, useState } from 'react';

import Calibration from './01_Calibration';
import Parameters from './02_Parameters';
import VideoStream from './03_VideoStream';
import FailSafe from './04_FailSafe';
import Ntrip from './05_Ntrip';
import styles from './index.module.scss';

import ModalWrapper from '@/components/ui/ModalWrapper';
import { ModalService as modal } from '@/libs/Modal';

const cx = classNames.bind(styles);

const Modal = ({ robot }) => {
  const isArduPilot = useMemo(() => {
    return robot.model.maker.includes('ArduPilot');
  }, []);

  const [activeTabIndex, setActiveTabIndex] = useState(isArduPilot ? 0 : 1);

  const selectTab = (e) => {
    setActiveTabIndex(Number(e.target.dataset.index));
  };

  const close = () => {
    modal.hide();
  };

  return (
    <ModalWrapper className={cx('container')}>
      <div className={cx('content')}>
        <div className={cx('tabs')}>
          {isArduPilot && (
            <div data-index="0" className={cx(['tab', { active: activeTabIndex === 0 }])} onClick={selectTab}>
              Calibration
            </div>
          )}
          <div data-index="1" className={cx(['tab', { active: activeTabIndex === 1 }])} onClick={selectTab}>
            Parameters
          </div>
          <div data-index="2" className={cx(['tab', { active: activeTabIndex === 2 }])} onClick={selectTab}>
            Video Stream
          </div>
          {isArduPilot && (
            <div data-index="4" className={cx(['tab', { active: activeTabIndex === 4 }])} onClick={selectTab}>
              Fail Safe
            </div>
          )}
          <div data-index="5" className={cx(['tab', { active: activeTabIndex === 5 }])} onClick={selectTab}>
            NTRIP
          </div>
        </div>
        <div className={cx('pane')}>
          {isArduPilot && activeTabIndex === 0 && <Calibration robot={robot} />}
          {activeTabIndex === 1 && <Parameters robot={robot} />}
          {activeTabIndex === 2 && <VideoStream robot={robot} />}
          {isArduPilot && activeTabIndex === 4 && <FailSafe robot={robot} />}
          {activeTabIndex === 5 && <Ntrip robot={robot} />}
        </div>
      </div>
      <button type="button" className={cx('button')} onClick={close}>
        Close
      </button>
    </ModalWrapper>
  );
};

export default Modal;
